export const DEFAULT_REFETCH_INTERVAL_MS = 9000;
